import { render, staticRenderFns } from "./InvoicingMainView.vue?vue&type=template&id=cbffbea2&scoped=true"
import script from "./InvoicingMainView.vue?vue&type=script&lang=js"
export * from "./InvoicingMainView.vue?vue&type=script&lang=js"
import style0 from "./InvoicingMainView.vue?vue&type=style&index=0&id=cbffbea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbffbea2",
  null
  
)

export default component.exports